/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Delete';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const DeleteIcon = withMuiAdapter(Base, 'Delete');
